/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GenericOrderConfirmAttributesContact } from './generic-order-confirm-attributes-contact';
/**
 * 
 * @export
 * @interface GenericOrderConfirmAttributes
 */
export interface GenericOrderConfirmAttributes {
    /**
     * 
     * @type {number}
     * @memberof GenericOrderConfirmAttributes
     */
    attendees?: number | null;
    /**
     * 
     * @type {GenericOrderConfirmAttributesContact}
     * @memberof GenericOrderConfirmAttributes
     */
    contact: GenericOrderConfirmAttributesContact;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    endDate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    paymentIframe?: string;
    /**
     * 
     * @type {any}
     * @memberof GenericOrderConfirmAttributes
     */
    paymentIntegrationData?: any;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    paymentIntegrationType?: GenericOrderConfirmAttributesPaymentIntegrationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    paymentMethod?: GenericOrderConfirmAttributesPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    recaptchaResponseToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    segmentationType: GenericOrderConfirmAttributesSegmentationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GenericOrderConfirmAttributes
     */
    startDate?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum GenericOrderConfirmAttributesPaymentIntegrationTypeEnum {
    Paycomet = 'paycomet',
    Freedompay = 'freedompay',
    Stripe = 'stripe'
}
/**
    * @export
    * @enum {string}
    */
export enum GenericOrderConfirmAttributesPaymentMethodEnum {
    CREDITCARD = 'CREDIT_CARD',
    REQUESTFORPROPOSAL = 'REQUEST_FOR_PROPOSAL'
}
/**
    * @export
    * @enum {string}
    */
export enum GenericOrderConfirmAttributesSegmentationTypeEnum {
    CONGRESS = 'CONGRESS',
    GROUPTRAVEL = 'GROUP_TRAVEL',
    INCENTIVES = 'INCENTIVES',
    MEETINGORCONFERENCE = 'MEETING_OR_CONFERENCE',
    SOCIALEVENT = 'SOCIAL_EVENT',
    WEDDING = 'WEDDING'
}

